  <!--Loading Spinner-->
  <div *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>

  <section class="content">
   <div class="container-fluid">
    <div class="card">
        <div class="card-header">
          <h3 class="card-title">Received Vehicle Details</h3>
            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
              {{errorMessage}}
            </div>
            <!--Success Message-->
            <div class="alert alert-success" role="alert" *ngIf="successMessage">
              {{successMessage}}
            </div>
            <div class="dropdown" style="float: right; margin-right: 70px;" *ngIf="userPermissions.includes('received-vhcl-add-spare-parts') || userPermissions.includes('received-vhcl-del-spare-parts') || userPermissions.includes('del-vhcl-reloc-photos')">
              <button type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown">
                Action
              </button>
              <div class="dropdown-menu">
                <a (click)="openAddSparePartsModal($event,receive_log_id)" href="#" class="dropdown-item" *ngIf="userPermissions.includes('received-vhcl-add-spare-parts')"><i
                  class="fa fa-plus-circle" aria-hidden="true">&nbsp;</i>Add Spare Parts</a>
                <a (click)="openRemoveSparePartsModal($event)" href="#" class="dropdown-item" *ngIf="userPermissions.includes('received-vhcl-del-spare-parts')"><i
                  class="fa fa-minus-circle" aria-hidden="true">&nbsp;</i>Remove Spare Parts</a>
                <div class="dropdown-divider"></div>
                <a (click)="openDeletePhotosModal($event)" href="#" class="dropdown-item" *ngIf="photos && photos.length > 0 && userPermissions.includes('del-vhcl-reloc-photos')"><i
                  class="fa fa-trash" aria-hidden="true">&nbsp;</i>Delete Photos</a>
              </div>
            </div>
        </div>
        <!-- /.card-header -->
        <div class="card card-solid">
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-sm-6">
                  <h3 class="d-inline-block d-sm-none">Received Vehicle Details</h3>
                  <div class="col-12">
                      <div id="photoCarousel" class="carousel slide" data-ride="carousel">
                          <ol class="carousel-indicators">
                              <li *ngFor="let photo of photos; let i = index" [class.active]="i === 0" data-target="#photoCarousel" [attr.data-slide-to]="i"></li>
                          </ol>
                          
                          <div class="carousel-inner">
                              <div *ngFor="let photo of photos; let i = index" class="carousel-item" [class.active]="i === 0">
                                  <div class="carousel-content-wrapper position-relative">
                                      <img [src]="photo.image_url" class="d-block w-100" alt="Vehicle Photo" />
                                  </div>
                              </div>
                          </div>
                      
                          <a class="carousel-control-prev" href="#photoCarousel" role="button" data-slide="prev">
                              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                              <span class="sr-only">Previous</span>
                          </a>
                          <a class="carousel-control-next" href="#photoCarousel" role="button" data-slide="next">
                              <span class="carousel-control-next-icon" aria-hidden="true"></span>
                              <span class="sr-only">Next</span>
                          </a>
                      </div>           
                  </div>
                  <div class="col-12" *ngIf="activity_logs && activity_logs.length > 0">
                    <div class="table-responsive">         
                        <table class="table">
                          <thead>
                            <tr>
                              <th>Date</th>
                              <th>Name</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let activity_log of activity_logs">
                              <td>{{activity_log.created_at | date: 'dd-MM-yyyy hh:mm:ss a'}}</td>
                              <td>{{activity_log.name}}</td>
                              <td>{{activity_log.description}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                  </div>
              </div>
              <div class="col-12 col-sm-6">
                  <h3 class="my-3">{{vehicle?.data?.make}} {{vehicle?.data?.model}}</h3>
                  <div class="row clearfix">
                      <div class="col-md-12">
                          <div class="table-responsive">          
                              <table class="table">
                                <tbody>
                                  <tr>
                                    <td><b>Chassis No.:</b>&nbsp;{{vehicle.data.chassis_no}}</td>
                                    <td><b>Engine CC:</b>&nbsp;{{vehicle.data.engine_cc}}</td>
                                    <td><b>Engine No.:</b>&nbsp;{{vehicle.data.engine_no}}</td>
                                  </tr>
                                  <tr>
                                      <td><b>Transmission:</b>&nbsp;{{vehicle.data.transmission}}</td>
                                      <td><b>Body Type:</b>&nbsp;{{vehicle.data.body_type}}</td>
                                      <td><b>Drive:</b>&nbsp;{{vehicle.data.drive}}</td>
                                  </tr>
                                  <tr>
                                      <td><b>Fuel:</b>&nbsp;{{vehicle.data.fuel}}</td>
                                      <td><b>Mileage:</b>&nbsp;{{vehicle.data.mileage}}</td>
                                      <td><b>Colour:</b>&nbsp;{{vehicle.data.colour}}</td>
                                  </tr>
                                  <tr>
                                      <td><b>Year:</b>&nbsp;{{vehicle.data.year}}</td>
                                      <td><b>Weight:</b>&nbsp;{{vehicle.data.weight}}</td>
                                      <td><b>CBM:</b>&nbsp;{{vehicle.data.cbm}}</td>
                                  </tr>
                                  <tr>
                                      <td><b>From:</b>&nbsp;{{vehicle.data.from_location}}</td>
                                      <td><b>To:</b>&nbsp;{{vehicle.data.received_at}}</td>
                                      <td><b>Transferred On:</b>&nbsp;{{vehicle.data.transferred_on| date: 'dd-MM-yyyy h:mm a'}}</td>
                                  </tr>
                                  <tr>
                                      <td><b>Transferred By:</b>&nbsp;{{vehicle.data.transferred_by}}</td>
                                      <td><b>Received On:</b>&nbsp;{{vehicle.data.received_on | date: 'dd-MM-yyyy h:mm a'}}</td>
                                      <td><b>Received By:</b>&nbsp;{{vehicle.data.received_by}}</td>
                                  </tr>
                                </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
                  <div class="row clearfix">
                      <div class="col-md-12">
                          <h6><b>Available Spare Parts</b></h6>
                          <div class="spare-parts-container">
                              <div class="spare-parts-column" *ngFor="let column of spare_parts_columns">
                                  <span *ngFor="let spare_part of column" class="spare-parts-item">
                                      {{ spare_part.name }}
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="row clearfix">
                      <div class="col-md-12">
                          <div class="form-group">
                              <label>Comment:</label>
                              <p>{{vehicle.data.comment}}</p>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
          <!-- /.card-body -->
        </div>
        <!-- /.card-body -->
    </div>
   </div>
   </section>

  <div class="modal fade" #DeletePhotosModal tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Delete Photos</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!--Error message-->
        <div class="alert alert-danger" role="alert" *ngIf="delPhotosPopupErrorMessage">
            {{delPhotosPopupErrorMessage}}
        </div>
        <table class="table" *ngFor="let photo of photos">
          <td>
            <img src="{{photo.image_url}}" height="70" width="120"/>
          </td>
          <td>
            <input type="checkbox" class="form-control" [(ngModel)]="photo.checked" (change)="checkboxChange($event, photo.image_url)" id="vehicle" name="photo">
          </td>
        </table>
        <div class="d-flex justify-content-end mr-4 mb-3">
          <div class="btn btn-danger btn-sm btn-flat" (click)="deletePhotos()">
            <i class="fas fa-trash fa-sm mr-2"></i>
            Delete
          </div>
        </div>        
      </div>
    </div>
  </div>

<div class="modal fade" #AddSparePartsModal tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add More Spare Parts</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!--Error message-->
      <div class="alert alert-danger" role="alert" *ngIf="addSparePartsPopupErrorMessage">
          {{addSparePartsPopupErrorMessage}}
      </div>
      <div class="col-md-12">
        <div class="row">
            <div class="col-md-12">
                <input type="text" class="form-control" placeholder="Type here to search search..." (input)="onSearchAddtlSparePartsChange($event)">
            </div>
        </div>
      </div>
      <table class="table">
        <tr *ngFor="let addtl_part of addtl_spare_parts | searchSparePart: searchAddtlPartsText | paginate: { itemsPerPage: 10, currentPage: addtl_spare_parts_page, totalItems: this.addtl_spare_parts_count }">
          <td><input type="checkbox" [(ngModel)]="addtl_part.checked" (change)="addSparePartCheckboxChange($event, addtl_part.part_id)" id="addtl_spare_part" name="addtl_spare_part" class="form-control"></td>
          <td>{{ addtl_part.name }}</td>
        </tr>
      </table>
      <pagination-controls (pageChange)="addSparePartsPageChangeEvent($event)"></pagination-controls>
      <div class="d-flex justify-content-end mr-4 mb-3">
        <div class="btn btn-success btn-sm btn-flat" (click)="addSpareParts()">
          <i class="fas fa-plus-circle fa-sm mr-2"></i>
          Add
        </div>
      </div>        
    </div>
  </div>
</div>

<div class="modal fade" #RemoveSparePartsModal tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Remove Spare Parts</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <!--Error message-->
      <div class="alert alert-danger" role="alert" *ngIf="removeSparePartsPopupErrorMessage">
          {{removeSparePartsPopupErrorMessage}}
      </div>
      <div class="col-md-12">
        <div class="row">
            <div class="col-md-12">
                <input type="text" class="form-control" placeholder="Type here to search..." (input)="onSearchSparePartsToRemoveChange($event)">
            </div>
        </div>
      </div>
      <table class="table">
        <tr *ngFor="let part of spare_parts | searchSparePart: searchPartsToRemoveText | paginate:{ itemsPerPage: 10, currentPage: remove_spare_parts_page, totalItems: remove_spare_parts_count }">
          <td><input type="checkbox" [(ngModel)]="part.checked" (change)="removeSparePartCheckboxChange($event, part.part_id)" id="spare_part" name="spare_part" class="form-control"></td>
          <td>{{ part.name }}</td>
        </tr>
      </table>
      <pagination-controls (pageChange)="removeSparePartsPageChangeEvent($event)"></pagination-controls>
      <div class="d-flex justify-content-end mr-4 mb-3">
        <div class="btn btn-success btn-sm btn-flat" (click)="removeSpareParts()">
          <i class="fas fa-minus-circle fa-sm mr-2"></i>
          Remove
        </div>
      </div>        
    </div>
  </div>
</div>